@import (reference) '../../../../constants/spacing.module.less';

.menu-print-dropdown {
  max-width: 120px;
  margin-left: 10px;
}

.menu-dropdown-disabled {
  opacity: 0.6;
  pointer-events: none;
}

.actions-button {
  height: 32px;
  display: flex;
  align-items: center;
  background-color: var(--white);
  padding-left: @space-12;
  padding-right: @space-4;
  border-radius: 4px;
  border: 1px solid var(--gray-AFB3B6);
}
